import React, { useState } from 'react';
import axios from 'axios';
import './PatentForm.css';
import PatentPDFGenerator from '../PatentPDFGenerator'; // ✅ import this
import { useNavigate } from 'react-router-dom';
import Preview from '../preview/preview';
import config from '../config/config';
import mammoth from 'mammoth';


function IndivisualSection() {
    const BASE_URL = config.mode === "dev" ? config.URL : config.LiveURL;
    const [overview, setOverview] = useState('');
    const [loading, setLoading] = useState(false);
    const [select, setSelect] = useState('');
    const [selectedSections, setSelectedSections] = useState([
        'title',
        'field',
        'background',
        'objects',
        'Summary',
        'description',
        'claim',
    ]);
    const navigate = useNavigate();
    const [patentData, setPatentData] = useState(null);

    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onload = async (event) => {
            const arrayBuffer = event.target.result;

            try {
                const result = await mammoth.extractRawText({ arrayBuffer });
                console.log("result",result);
                setOverview(result.value); // Plain text output
            } catch (error) {
                console.error("Error reading .docx file:", error);
            }
        };

        reader.readAsArrayBuffer(file);
    };

    const handleIndividualSection = async () => {
        setLoading(true);
        try {
            const response = await axios.post(`${BASE_URL}` + 'api/generateSinglePatentSection', {
                overview,
                select
            });
            const patentData = response.data.data;
            setPatentData(patentData);
            navigate('/preview', { state: { data: patentData, overview: overview } });
        } catch (error) {
            console.error(`Error generating ${select}:`, error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='formroot' >
            <div style={{ display: "flex", justifyContent: "end", margin: "10px" }}>
                {patentData && <button onClick={() => navigate('/preview')} className="button secondary-button">
                    Preview
                </button>}
                <button onClick={() => navigate('/file-viewer')} className="button secondary-button">
                    Modify Prompt
                </button>
                <button onClick={() => navigate('/patentform')} className="button secondary-button">
                    Home Page
                </button>
            </div>
            <div className="patent-form-container">
                <h1 className="title">Patent Builder (Individual Section)</h1>



                <label className="label">Project Overview</label>
                <select
                    value={select}
                    onChange={(e) => setSelect(e.target.value)}
                    style={{ padding: '8px', marginBottom: '15px', display: 'block' }}
                >
                    <option value="">-- Select Section --</option>
                    {selectedSections.map((option) => (
                        <option key={option} value={option}>
                            {option}
                        </option>
                    ))}
                </select>

                <label className="label">Upload .docx for Overview</label>
                <input
                    type="file"
                    accept=".docx"
                    onChange={handleFileUpload}
                    style={{ marginBottom: '15px',marginLeft:"20px" }}
                />
                <textarea
                    value={overview}
                    onChange={(e) => setOverview(e.target.value)}
                    placeholder="Enter your project overview here"
                    className="textarea"
                    required
                />
                <button type="submit" disabled={loading} className="button"
                    onClick={handleIndividualSection}>
                    {loading ? 'Generating...' : `Generate ${select}`}
                </button>
            </div>
        </div>
    );
};


export default IndivisualSection